import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

type State = {
  element: HTMLElement | null;
  isBubbleOverDock: boolean;
};
type Actions = {
  registerElement: (element: HTMLElement | null) => void;
  setBubbleOverDock: (isBubbleOverDock: boolean) => void;
};
type ProPilotDockStore = State & { actions: Actions };

const useProPilotDockStore = create<ProPilotDockStore>((set) => ({
  element: null,
  isBubbleOverDock: false,
  actions: {
    registerElement: (element) => set({ element }),
    setBubbleOverDock: (isBubbleOverDock) => set({ isBubbleOverDock })
  }
}));

export const useProPilotDockElement = (): HTMLElement | null =>
  useProPilotDockStore((state) => state.element);

export const useIsBubbleOverProPilotDock = (): boolean =>
  useProPilotDockStore((state) => state.isBubbleOverDock);

export const useProPilotDockActions = () => useProPilotDockStore(useShallow((state) => state.actions));
